import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Header from './../header/header';
import MainForm from './../mainform/mainform';
import Table from './../table/table';
import SingleMachine from './../singlemachine/singlemachine';
import News from './../newsmonkey/newsmonkey';
import BreakDown from './../breakdown/breakdown';
import BreakbyClass from './../breakbyclass/breakbyclass';

function Navbar() {
  const pageSize = 6;
  const apiKey = '362db9f6d0ae4aac9f1d865ae1a87455';
  return (
  <Router>
    <div>
<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <span className="navbar-brand"><i className="fa fa-envira"></i></span>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
      <li className="nav-item">
        <Link className="nav-link" to="/link">Home</Link>
      </li>
	  <li className="nav-item">
        <Link className="nav-link" to="/table">Table</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/newsmonkey">News Monkey</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/breakdown">Break Down</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/breakbyclass">BreakbyClass</Link>
      </li>
    </ul>
    <form className="form-inline my-2 my-lg-0">
    
    </form>
  </div>
</nav>
<Switch>
      <Route exact path="/home" component={MainForm}></Route>
      <Route exact path="/link" component={Header}></Route>
		  <Route exact path="/table" component={Table}></Route>
      <Route exact path="/" component={Table}></Route>
      <Route exact path="/singlemachine" component={SingleMachine}></Route>
		  <Route exact path="/breakdown" component={BreakDown}></Route>
      <Route exact path="/breakbyclass" component={BreakbyClass}></Route>
      <Route exact path="/newsmonkey"><News apiKey={apiKey} key="general" pageSize={pageSize} country="in" category="general"/></Route>
      </Switch>
    </div>
	</Router>
  );
}

export default Navbar;
